import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { compose } from 'redux';

import VideoNUX from 'common/common/VideoNUX';
import { DevelopersCompanyContext } from 'common/containers/DevelopersCompanyContainer';
import WidgetDocsWarning from 'common/developers/docs/widget/WidgetDocsWarning';
import WidgetDocsHomeHelmet from 'common/helmets/WidgetDocsHomeHelmet';
import LazyLoadedImage from 'common/LazyLoadedImage';
import Link from 'common/Link';
import devURL from 'common/util/devURL';
import withContexts from 'common/util/withContexts';

import VideoThumbnailWidget from 'img/video-thumbnail-widget.jpg';
import WidgetDevices from 'img/widget-devices.png';

import 'css/components/developers/docs/widget/_WidgetDocsHome.scss';

class WidgetDocsHome extends Component {
  static propTypes = {
    company: PropTypes.shape({
      name: PropTypes.string,
    }),
  };

  renderEasySetup() {
    const { company } = this.props;
    if (!company) {
      return null;
    }

    const inviteURL = devURL('https://' + company.subdomain + '.canny.io/admin/settings/team');
    return (
      <div className="easySetup">
        <span className="icon-bolt" />
        <div className="main">
          Setup is easy! It typically takes an engineer less than 30&nbsp;minutes. Need a teammate
          to set this up?&nbsp;
          <a className="invite" href={inviteURL} rel="noopener" target="_blank">
            Send them an&nbsp;invite
          </a>
        </div>
      </div>
    );
  }

  renderLink() {
    const { company } = this.props;
    if (!company || company.loading) {
      return 'your-company.canny.io';
    }

    const { domains, subdomain } = company;
    return domains[0] ? domains[0] : subdomain + '.canny.io';
  }

  render() {
    return (
      <div className="widgetDocsHome">
        <WidgetDocsHomeHelmet />
        <WidgetDocsWarning />
        <VideoNUX
          name="widgetOverview"
          pillText="Learn"
          text="Let's take a look at the difference between the Canny feedback widget and full Canny&nbsp;portal."
          videoThumbnail={VideoThumbnailWidget}
          videoURL="https://www.loom.com/embed/dd6068981cde465ea8e1f86831188039?autoplay=1"
        />
        <div className="title">Canny&nbsp;Widget</div>
        <div className="text">
          The widget lets you embed Canny into a full page of your website, rather than hosting
          Canny on a subdomain ({this.renderLink()}).
        </div>
        <div className="text">
          Both methods will work seamlessly with your existing user accounts, so you know exactly
          who is giving feedback.
        </div>
        {this.renderEasySetup()}
        <div className="links">
          <Link className="link" to="/install/widget/web">
            See documentation for&nbsp;web
          </Link>
          <Link className="link" to="/install/widget/mobile">
            See documentation for&nbsp;mobile
          </Link>
        </div>
        <div className="examples">
          <div className="text">Here's a live example:</div>
          <a
            className="link"
            href="https://kitsu.app/feedback/feature-requests"
            rel="noopener"
            target="_blank">
            Kitsu
          </a>
        </div>
        <LazyLoadedImage className="widgetDevices" src={WidgetDevices} />
      </div>
    );
  }
}

export default compose(withContexts({ company: DevelopersCompanyContext }), hot)(WidgetDocsHome);
